// Shared device-detection helper for photo capture flows.
// Extracted from VisualiserNew so AddPhotoSheet can share the exact same
// touch-device heuristic (mobile UA OR touch-capable + <1024 px viewport).

export function isTouchDevice() {
  if (typeof window === "undefined") return false;
  const ua = navigator.userAgent || "";
  const touchCapable = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const mobileUA = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  return mobileUA || (touchCapable && window.innerWidth < 1024);
}
